export default function SvgBluePluse() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9565 11.7888H11.8137V19.9316H9.0994V11.7888H0.956543V9.0745H9.0994V0.931641H11.8137V9.0745H19.9565V11.7888Z"
        fill="#0B6CFF"
      />
    </svg>
  );
}
